import React from 'react';

import { AsyncTable } from '_src/components';
import services from '_src/services';
import { PageWrapper } from '_src/shared/styles';
import { camelToSnakeCase } from '../../utils/helpers';
import { useSubmissionReportFilters } from '../SubmissionReport';

const StaffFMCSASubmissionsQueueReport = ({ isReusable }) => {
  const resource = 'staffFMCSASubmissionsQueue';
  const config = services[resource];

  const { renderFilters, filterParams, setFilterParams } = useSubmissionReportFilters({
    includePendingStatus: true
  });

  return (
    <PageWrapper style={{ padding: isReusable ? 0 : '25px' }}>
      {renderFilters()}
      <div style={{ overflowX: 'auto' }}>
        <AsyncTable
          resource={resource}
          pagination
          config={{
            ...config,
            table: [...config.table]
          }}
          fileName={resource}
          params={filterParams}
          onChange={(pagination, filters, sorter) => {
            if (!!sorter.field) {
              setFilterParams(prev => ({
                ...prev,
                orderBy: camelToSnakeCase(
                  sorter.field === 'submittedDate'
                    ? 'submissionDate'
                    : sorter.field === 'student'
                      ? 'studentFullName'
                      : sorter.field === 'submittedToQueueBy'
                        ? 'submittedByFullName'
                        : sorter.field
                ),
                order: sorter.order === 'ascend' ? 'asc' : 'desc'
              }));
            }
          }}
        />
      </div>
    </PageWrapper>
  );
};

export default StaffFMCSASubmissionsQueueReport;
